import React, {useState, useEffect} from "react";

const ReportModal = ({report, universityId, onClose, onSave}) => {
    const [reportUrl, setReportUrl] = useState("");
    const [selectedUniversity, setSelectedUniversity] = useState(universityId || "");
    const [universities, setUniversities] = useState([]);
    const [isLoadingUniversities, setIsLoadingUniversities] = useState(false); // Loading state for universities

    const [isSaving, setIsSaving] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const role = localStorage.getItem("role");

    const fetchUniversities = async () => {
        if (role === "super_admin") {
            setIsLoadingUniversities(true);
            try {
                const response = await fetch(`${apiUrl}/universities`);
                if (!response.ok) throw new Error("Failed to fetch universities.");
                const data = await response.json();
                setUniversities(data);
            } catch (error) {
                console.error("Error fetching universities:", error);
                setUniversities([]);
            } finally {
                setIsLoadingUniversities(false);
            }
        }
    };

    useEffect(() => {
        fetchUniversities();
    }, []); // Fetch universities on component mount

    useEffect(() => {


        if (report) {
            setReportUrl(report.report_url);
            setSelectedUniversity(report.university.id || "");
        } else {
            setReportUrl("");
            setSelectedUniversity(universityId || "");
        }
    }, [report, universityId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setFeedbackMessage("");

        const payload = {
            report_url: reportUrl,
            university_id: selectedUniversity,
        };

        const endpoint = report
            ? `${apiUrl}/reports/${report.id}`
            : `${apiUrl}/reports`;
        const method = report ? "PUT" : "POST";

        try {
            const response = await fetch(endpoint, {
                method,
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || "Failed to save report.");
            }

            setFeedbackMessage("Report saved successfully.");
            onSave();
            setTimeout(onClose, 2000); // Close modal after 2 seconds
        } catch (error) {
            console.error(error);
            setFeedbackMessage(error.message || "An error occurred while saving.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                }}
            >
                <h4>{report ? "Edit Report" : "Add Report"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Report URL</label>
                        <input
                            type="text"
                            className="form-control"
                            value={reportUrl}
                            onChange={(e) => setReportUrl(e.target.value)}
                            required
                        />
                    </div>

                    {role === "super_admin" && (

                        <div className="form-group">
                            <label>University</label>
                            <select
                                className="form-control"
                                value={selectedUniversity}
                                onChange={(e) => setSelectedUniversity(e.target.value)}

                            >
                                <option value="" disabled>
                                    Select a University
                                </option>

                                {universities.map((uni) => (
                                    <option key={uni.id} value={uni.id}>
                                        {uni.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="form-footer">
                        {isSaving ? (
                            <p>Saving...</p>
                        ) : (
                            <button type="submit" className="btn btn-primary">
                                Save
                            </button>
                        )}
                        &nbsp;
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isSaving}
                        >
                            Cancel
                        </button>
                    </div>
                    {feedbackMessage && (
                        <p style={{color: feedbackMessage.includes("successfully") ? "green" : "red"}}>
                            {feedbackMessage}
                        </p>
                    )}
                </form>
            </div>
        </div>
    );
};

export default ReportModal;